import { render, staticRenderFns } from "./ProductAttributesDeposit.vue?vue&type=template&id=48aaeea6&scoped=true&lang=pug&"
import script from "./ProductAttributesDeposit.vue?vue&type=script&lang=js&"
export * from "./ProductAttributesDeposit.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributesDeposit.vue?vue&type=style&index=0&id=48aaeea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aaeea6",
  null
  
)

/* custom blocks */
import block0 from "./ProductAttributesDeposit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports